import React from 'react';

const DisplayItCard = ({ header, content }) => (
  <div className='performance-box-display-it-card'>
    <div className='performance-box-display-it-header'>
      {header}
    </div>
    {content}
  </div>
);

export default DisplayItCard;



// WEBPACK FOOTER //
// ./src/components/store-performance/display-it/display-it-card.jsx